module.exports = __webpack_public_path__ + "static/media/va.56a808f7.svg";